import { SelectionCard } from '@jouzen/ecom-components/v3/SelectionCard';
import { useTranslations } from 'next-intl';

import { useWizardStateContext } from '@/app/[locale]/product/_contexts/WizardStateProvider';
import MembershipSelection from '@/app/[locale]/product/_steps/enums/MembershipSelection';
import useCurrency from '@/app/hooks/useCurrency';

const OneYearMembershipSelector = () => {
  const t = useTranslations();
  const {
    hasMaxRingCount,
    membershipSelection,
    oneYearMembership,
    setMembershipSelection,
  } = useWizardStateContext();
  const { currencyCode } = useCurrency();

  const amount = oneYearMembership?.price?.amount;
  const oneYearMembershipPrice = amount ?? 69.99;
  const oneYearMembershipDiscount =
    oneYearMembership?.discountedPrice.discountedPrice?.amount;
  const discount =
    oneYearMembershipPrice && oneYearMembershipDiscount
      ? oneYearMembershipPrice - oneYearMembershipDiscount
      : 0;

  const handleBundleMembershipClick = (
    membershipInput: MembershipSelection,
  ) => {
    if (membershipSelection === membershipInput) {
      setMembershipSelection(MembershipSelection.OneMonth);
    } else {
      setMembershipSelection(membershipInput);
    }
  };

  return (
    <SelectionCard
      data-cy="bundle-membership-one-year"
      cardSelected={membershipSelection === MembershipSelection.OneYear}
      currencyCode={currencyCode}
      disabled={Boolean(hasMaxRingCount)}
      price={oneYearMembershipPrice}
      discount={discount}
      title={t('12_months_prepaid')}
      onCheckBoxClick={() =>
        handleBundleMembershipClick(MembershipSelection.OneYear)
      }
    />
  );
};

export default OneYearMembershipSelector;
